// extracted by mini-css-extract-plugin
module.exports = {"wrap":"M3DevicesMockup-module--wrap--1y_YC","svg":"M3DevicesMockup-module--svg--Rt_Ai"};